export default __webpack_public_path__ + "static/media/table.f425f7f5.svg";